import { render } from "./IconBack.vue?vue&type=template&id=63e66568&ts=true"
import script from "./IconBack.vue?vue&type=script&lang=ts"
export * from "./IconBack.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__